import * as React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { BREAKPOINT, COLOR } from '@latitude/core/utils/constants';
export const CalloutOuter = /*#__PURE__*/styled.div.withConfig({
  displayName: "Callout__CalloutOuter",
  componentId: "sc-1teg4uu-0"
})(["width:100%;padding:40px 15px;background-color:", ";", ""], COLOR.BLUE_DARK, _ref => {
  let {
    isResponsive
  } = _ref;
  return isResponsive && `@media (min-width: ${BREAKPOINT.XL}) {
      padding: 32px 0;
    }`;
});
export const CalloutInner = /*#__PURE__*/styled.div.withConfig({
  displayName: "Callout__CalloutInner",
  componentId: "sc-1teg4uu-1"
})(["display:flex;flex-direction:column;justify-content:center;max-width:1140px;margin:0 auto;", ""], _ref2 => {
  let {
    isResponsive
  } = _ref2;
  return isResponsive && `@media (min-width: ${BREAKPOINT.LG}) {
      flex-direction: row;
    }`;
});
const Callout = _ref3 => {
  let {
    children,
    className,
    id,
    isResponsive = true
  } = _ref3;
  const props = {
    id,
    isResponsive
  };
  return /*#__PURE__*/React.createElement(CalloutOuter, Object.assign({
    className: classnames('callout', className)
  }, props), /*#__PURE__*/React.createElement(CalloutInner, props, children));
};
export default Callout;